import { getQueryKeys } from "@/app/_module/services/helper";
import AgencyTokenManager from "@/app/_module/services/agencyTokenManager";

const namespace = "ai-calling";

let cachedAgencyContext: { agencyId: string | null } | null = null;
let lastAgencyId: string | null = null;

const getAgencyContext = () => {
  const agencyId = AgencyTokenManager.getCurrentAgencyId();
  if (agencyId !== lastAgencyId) {
    lastAgencyId = agencyId;
    cachedAgencyContext = agencyId ? { agencyId } : { agencyId: null };
  }
  return cachedAgencyContext!;
};

const aiCallingQueryKeys = {
  ...getQueryKeys(namespace),

  // Config
  config: () => [namespace, "config", getAgencyContext()] as const,
  voices: (provider?: string) => [namespace, "voices", provider ?? "default"] as const,
  providers: () => [namespace, "providers"] as const,
  promptTemplates: () => [namespace, "prompt-templates"] as const,

  // Campaigns
  campaigns: () => [namespace, "campaigns", getAgencyContext()] as const,
  campaignList: (filters?: { page?: number; pageSize?: number }) =>
    [namespace, "campaigns", "list", filters, getAgencyContext()] as const,
  campaignDetail: (id: string) =>
    [namespace, "campaigns", "detail", id, getAgencyContext()] as const,
  campaignLeads: (id: string, filters?: { status?: string; page?: number }) =>
    [namespace, "campaigns", id, "leads", filters, getAgencyContext()] as const,
  campaignStats: (id: string) =>
    [namespace, "campaigns", id, "stats", getAgencyContext()] as const,

  // Monitoring
  dashboard: () => [namespace, "monitoring", "dashboard", getAgencyContext()] as const,
  activeCalls: () => [namespace, "monitoring", "active-calls", getAgencyContext()] as const,
  recentDispositions: (limit?: number) =>
    [namespace, "monitoring", "dispositions", limit, getAgencyContext()] as const,

  // Usage
  currentUsage: () => [namespace, "usage", "current", getAgencyContext()] as const,
  usageHistory: (startDate?: string, endDate?: string) =>
    [namespace, "usage", "history", startDate, endDate, getAgencyContext()] as const,

  // AI Texting — every key starts with [namespace, "texting"] so texting() invalidates them all
  texting: () => [namespace, "texting"] as const,
  textingEligibility: () => [namespace, "texting", "eligibility", getAgencyContext()] as const,
  textingStats: () => [namespace, "texting", "stats", getAgencyContext()] as const,
  textingConversations: (filters?: { status?: string; page?: number; pageSize?: number }) =>
    [namespace, "texting", "conversations", filters, getAgencyContext()] as const,
  textingConversation: (id: string) =>
    [namespace, "texting", "conversation", id, getAgencyContext()] as const,
};

export default aiCallingQueryKeys;
